export const actionTypes = {
  INITIALIZE: 'INITIALIZE',
};

export default actionTypes;
